import { Avatar, Box, Divider } from '@mui/material';
import { DialogWrapper } from '../../../../shared/components/common/dialogWrapper';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { BASE_URLS, IS_SA } from '../../../../config/appConfig';
import { RegionTypes } from '../../../../config/regions';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import SAflag from '../../../../assets/images/flag-sa.svg';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useTranslation } from 'react-i18next';
import { TextWrapper } from '../../../../shared/components/formUtilities/useTextWrapper';
import CheckIcon from '@mui/icons-material/Check';
import { RegionService } from '../../../../services/regionService';
import { AvailableLanguages } from '../../../../config/languages';
import i18next from 'i18next';
import { AppRoutes } from '../../../../constants/appRoutes';

const getCurrentLanguage = () =>
	AvailableLanguages.find((language) => language.lang === i18next.language) ||
	AvailableLanguages[0];

const SignUpPlatform = ({ onOpen, label }) => (
	<Box
		className="cursor-pointer flex items-center shadow-sm gap-2 px-2 py-[1px] rounded-md !border-none primary-bg"
		onClick={onOpen}>
		<Avatar sx={{ width: 18, height: 18 }} className={!IS_SA ? '!bg-transparent' : '!bg-white'}>
			{IS_SA ? (
				<img src={SAflag} alt="" width={18} height={18} />
			) : (
				<LanguageOutlinedIcon className="!text-white !text-[22px] opacity-95" />
			)}
		</Avatar>
		<Box className="text-white font-[500] !text-[14px]">{label}</Box>
	</Box>
);

export const Platform = ({ isShowNames = true, shortName = false }) => {
	const regionService = new RegionService();
	const [state, setState] = useState(false);
	const { t } = useTranslation();
	const { pathname } = useLocation();

	const regionLabel = regionService.currentRegion() === RegionTypes.SaudiArabia ? 'KSA' : 'Global';
	const languageLabel = shortName ? getCurrentLanguage().lang.toUpperCase() : getCurrentLanguage().name;
	const triggerLabel = `${regionLabel} · ${languageLabel}`;

	const onClose = () => setState(false);

	const isSignUpPage = () =>
		(pathname.includes(AppRoutes.InvestorRegistration) || pathname.includes(AppRoutes.BorrowerRegistartion)) &&
		!pathname.includes(AppRoutes.Login);

	const removeReturnUrl = () => {
		if (window.location.search.includes(AppRoutes.INafathVerification)) {
			const url = new URL(window.location.href);
			if (url.searchParams.has('returnUrl')) {
				url.searchParams.delete('returnUrl');
				window.history.replaceState({}, '', url.toString());
			}
		}
	};

	const onSelectRegion = (targetRegion) => {
		if (targetRegion === regionService.currentRegion()) return;
		const targetOrigin = targetRegion === RegionTypes.SaudiArabia ? BASE_URLS.sa : BASE_URLS.en;
		window.location.replace(
			`${targetOrigin}${window.location.pathname}${window.location.search}${window.location.hash}`
		);
	};

	return (
		<Box data-testid="platform">
			{isSignUpPage() ? (
				<SignUpPlatform onOpen={() => setState(true)} label={triggerLabel} />
			) : (
				<Box className="cursor-pointer flex items-center" onClick={() => setState(true)}>
					<Box className="mx-1">
						{IS_SA ? (
							<Avatar src={SAflag} sx={{ width: 18, height: 18 }}></Avatar>
						) : (
							<Avatar className="!bg-white" sx={{ width: 18, height: 18 }}>
								<LanguageOutlinedIcon className="!text-[#757575] !text-[22px] opacity-95" />
							</Avatar>
						)}
					</Box>
					<Box className="flex flex-0 items-center font-[500] cursor-pointer !text-[#757575] !text-[14px]">
						{isShowNames ? triggerLabel : null}
						<KeyboardArrowDownIcon
							className={!isShowNames ? '!text-[15px] -mx-[5px]' : ''}
						/>
					</Box>
				</Box>
			)}

			{state ? (
				<DialogWrapper
					title={t('countryLanguage')}
					maxWidth="xs"
					state={state}
					onClose={() => onClose(false)}
					content={
						<Box>
							<Box className="grid grid-flow-row gap-4 cursor-pointer">
								<Box
									onClick={() => onSelectRegion(RegionTypes.Global)}
									className={`py-2 px-3 bg-[#f7f7f7] flex items-center justify-between rounded-md platform-item ${regionService.currentRegion() === RegionTypes.Global ? 'active' : ''
										}`}>
									<Box className="flex items-center gap-2">
										<LanguageOutlinedIcon className="!text-[#757575] !text-[18px] opacity-95" />
										<TextWrapper classList="!text-[13px] platform-text" text="Global" />
									</Box>
									{regionService.currentRegion() === RegionTypes.Global ? (
										<CheckIcon className="!text-white !text-[18px]" />
									) : null}
								</Box>
								<Box
									onClick={() => onSelectRegion(RegionTypes.SaudiArabia)}
									className={`py-2 px-3 bg-[#f7f7f7] flex items-center justify-between rounded-md platform-item ${regionService.currentRegion() === RegionTypes.SaudiArabia ? 'active' : ''
										}`}>
									<Box className="flex items-center gap-2">
										<img src={SAflag} alt="" width={18} height={18} />
										<TextWrapper classList="!text-[13px] platform-text" text="Saudi Arabia" />
									</Box>
									{regionService.currentRegion() === RegionTypes.SaudiArabia ? (
										<CheckIcon className="!text-white !text-[18px]" />
									) : null}
								</Box>
							</Box>
							<Divider className="!py-1 !my-4" />
							<Box className="grid grid-flow-row gap-4 cursor-pointer">
								<Box
									onClick={() => {
										setState(false);
										removeReturnUrl();
										regionService.onChangeLanguage('en');
									}}
									className={`py-2 px-3 bg-[#f7f7f7] flex items-center justify-between rounded-md platform-item ${i18next.language === 'en' ? 'active' : ''
										}`}>
									<TextWrapper classList="!text-[13px] platform-text" text="English" />
									{i18next.language === 'en' ? (
										<CheckIcon className="!text-white !text-[18px]" />
									) : null}
								</Box>
								<Box
									onClick={() => {
										setState(false);
										removeReturnUrl();
										regionService.onChangeLanguage('ar');
									}}
									className={`py-2 px-3 bg-[#f7f7f7] flex items-center justify-between rounded-md platform-item ${i18next.language === 'ar' ? 'active' : ''
										}`}>
									<TextWrapper classList="!text-[13px] platform-text" text="العربية" />
									{i18next.language === 'ar' ? (
										<CheckIcon className="!text-white !text-[18px]" />
									) : null}
								</Box>
							</Box>
						</Box>
					}></DialogWrapper>
			) : null}
		</Box>
	);
};
